module.exports = __webpack_public_path__ + "static/media/sports_20.1fc8c5d1.jpg";